import { injectable } from 'inversify';
import { Component } from '../../../concepts/objects';
import { FromFirstMatchExportAdapter } from '../dataExport/ExportAdapter';
import { DefineSimpleDimension } from '../dataExport/addons/SimpleDimension';
import { JiraCard } from './JiraCard';

@injectable()
export class JiraCardExportAdapter extends FromFirstMatchExportAdapter {

    protected selector = (c: Component) => c.is(JiraCard);

    public readonly id = 'JiraCardExports';
    public readonly label = 'Jira Cards';
    public readonly priority = 10;
    public readonly defaults = true;
    public readonly columns = [
        DefineSimpleDimension(
            JiraCard,
            'Key',
            'Key',
            x => x.key,
        ),
        DefineSimpleDimension(
            JiraCard,
            'Summary',
            'Summary',
            x => x.record?.summary
        ),
        DefineSimpleDimension(
            JiraCard,
            'Parent',
            'Parent',
            x => x.record?.parent?.key
        ),
        DefineSimpleDimension(
            JiraCard,
            'IssueType',
            'IssueType',
            x => x.record?.issueType?.name
        ),
        DefineSimpleDimension(
            JiraCard,
            'Priority',
            'Priority',
            x => x.record?.priority?.name
        ),
        DefineSimpleDimension(
            JiraCard,
            'Status',
            'Status',
            x => x.record?.status?.name
        ),
        DefineSimpleDimension(
            JiraCard,
            'Assignee',
            'Assignee',
            x => x.record?.assignee?.displayName
        ),
    ];
}
